import React from 'react'
import styled from 'styled-components'
import { Modal } from 'antd'
import { Carousel } from 'antd'
import Button from 'src/components/Button'
import { IconLeftOutlined } from '@shared/icons'

type Props = {
  item: Array<any>
  isEdit: boolean
  title?: string
  pictureSeq?: number
  onCancel?: () => void
  onRemove?: (v: any) => any
  description?: string | React.ReactElement
}

export default function ImageViewerModal({
  item,
  title,
  isEdit,
  pictureSeq,
  onCancel,
  onRemove,
  description,
}: Props) {
  const carouselRef = React.createRef<any>()

  const [currentSeq, setCurrentSeq] = React.useState(pictureSeq)

  const handleRemove = () => {
    onRemove && onRemove(currentSeq)
  }

  React.useEffect(() => {
    carouselRef.current.goTo(pictureSeq)
  }, [pictureSeq])

  return (
    <>
      <ModalStyled
        title={title || 'Image Viewer'}
        centered
        open={true}
        onCancel={onCancel}
        width={1000}
        footer={null}>
        <>
          {description && <div className="ml-16">{description}</div>}
          {isEdit && (
            <ButtonContent>
              <Button.Delete onClick={handleRemove} className="mr-24" />
              {/* <Button.Delete onClick={onRemove} className="mr-24" /> */}
            </ButtonContent>
          )}
          {item.length > 1 && (
            <LeftArrow
              onClick={() => {
                carouselRef.current.prev()
              }}
            />
          )}
          <Carousel ref={carouselRef} afterChange={setCurrentSeq}>
            {item.map(img => (
              <div key={img.url}>
                <img
                  alt="img"
                  style={{
                    maxWidth: '100%',
                    width: 'auto',
                    // display: 'block',
                    margin: '100px auto',
                    boxShadow:
                      '0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)',
                  }}
                  src={img.url}
                />
              </div>
            ))}
          </Carousel>
          {item.length > 1 && (
            <RightArrow
              onClick={() => {
                carouselRef.current.next()
              }}
            />
          )}
        </>
      </ModalStyled>
    </>
  )
}

const ModalStyled = styled(Modal)`
  .ant-modal-header,
  .ant-modal-body {
    color: #fff;
    background: #272727;
  }

  .ant-modal-header {
    border-bottom: none;
  }

  .ant-modal-body {
    padding: 12px 0;
  }

  .ant-modal-title {
    color: #fff;
  }

  .ant-modal-close-icon {
    svg {
      fill: #fff;
    }
  }
`

const ButtonContent = styled.div`
  width: 100%;
  height: auto;
  background: #1b1d1d;
  padding: 10px;
`

const Arrow = styled(IconLeftOutlined)`
  position: absolute;
  top: 50%;
  width: 48px;
  height: 48px;
  z-index: 10;
  padding: 6.02px 8px 6.01px 8px;
  &:hover {
    cursor: pointer;
  }
`

const LeftArrow = styled(Arrow)`
  left: 16px;
`

const RightArrow = styled(Arrow)`
  right: 16px;
  transform: rotate(180deg);
`
